$(document).ready(function(){
    $("div.sb-widget").find(".advanced-filters").addClass('hide');
    $("div.sb-widget:first-child").find(".advanced-filters").removeClass('hide');
    $("div.sb-widget:first-child").addClass('toggle expanded');
    $("div.sb-widget").addClass('toggle');
    $("div.sb-widget").click(function(){
     if($(this).hasClass("toggle expanded")){
         $("div.sb-widget").removeClass('expanded');
         $("div.sb-widget").find(".advanced-filters").removeClass('hide');
         $(this).removeClass('expanded');
         $("div.sb-widget").find(".advanced-filters").addClass('hide');
     }
     else
     {
         $("div.sb-widget").removeClass('expanded');
         $("div.sb-widget").find(".advanced-filters").addClass('hide');
         $(this).addClass('toggle expanded');
         $(this).find(".advanced-filters").removeClass('hide');  	  	 
     }   
  });
     $(".use .advanced-filters li").sort(sort_li) // sort elements
     .appendTo('.use .advanced-filters'); // append again to the list
	 // sort function callback
	 function sort_li(a, b){
      return ($(b).data('position')) < ($(a).data('position')) ? 1 : -1;  
    	  
    } 
});